/**
 * Route guard for the clinical content Library surface: an environment-aware
 * audience gate ({@link useLibraryAudience}) that narrows the surface to ICT
 * professionals + clinical directors in production only. Outside production
 * every signed-in user is in the audience. The `libraryCms` env kill-switch
 * was retired at GA (flag-retired-at-GA convention); nav-level demo hiding is
 * an explicit `useDemoMode` check in `AuthenticatedLayoutChrome`.
 * @agentic connections
 */

import type { ReactNode } from "react";
import { PageContentSkeleton } from "@benchmark/ui/components/atomic";
import { NotFoundPage } from "@/pages";
import { useLibraryAudience } from "@/hooks/domain/useLibraryAudience";

/** Props for {@link RequireLibraryAccess}. @agentic connections */
export type RequireLibraryAccessProps = {
  children: ReactNode;
};

/**
 * Gates the Library route subtree behind the production audience gate.
 * @agentic connections
 */
export const RequireLibraryAccess = ({
  children,
}: RequireLibraryAccessProps) => {
  const { allowed, pending } = useLibraryAudience();

  if (pending) {
    return <PageContentSkeleton />;
  }

  return allowed ? <>{children}</> : <NotFoundPage />;
};
